import { ApiDividendInstruction, ApiOperationBase } from 'api/rtk-api'
import { PresentationalTable } from 'components/core-v2'

interface Props {
  operation: ApiOperationBase
}
export const DistributionTable = ({ operation }: Props) => {
  const { assetId, dividendAmountPerShare, exDividendDate, heldShares } =
    operation.associatedInstruction as ApiDividendInstruction
  return (
    <PresentationalTable
      headerRow={['Asset ID', 'Exe. Date', 'Reference Units', 'Amount per Unit', 'Amount']}
      rowOptions={[
        { width: '20%' },
        { width: '20%' },
        { width: '20%' },
        { width: '20%', align: 'right' },
        { width: '20%', align: 'right' }
      ]}
      rows={[
        [
          assetId,
          exDividendDate as any as string,
          heldShares,
          dividendAmountPerShare,
          (heldShares * dividendAmountPerShare).toFixed(2) || '–'
        ]
      ]}
    />
  )
}
